export function makeSmsName(type, sex, name, dieName, memberSecondType) {
  if (memberSecondType?.trim()) {
    return `${name}의 ${memberSecondType} 故 ${dieName}`;
  }

  const formatType = type?.replace(/\s+/g, "") || "";

  let result = name + "의 ";
  let gender = sex || "M";

  if (gender === "M") {
    if (formatType === "배우자" || formatType === "아내") {
      result += "남편";
    } else if (formatType === "부") {
      result += "아들";
    } else if (formatType === "모") {
      result += "아들";
    } else if (formatType === "외손" || formatType === "외손") {
      result += "외할아버지";
    } else if (
      formatType === "손" ||
      formatType === "손" ||
      formatType === "손"
    ) {
      result += "할아버지";
    } else if (formatType === "손부") {
      result += "시할아버님";
    } else if (formatType === "손서") {
      result += "처할아버님";
    } else if (formatType === "외손부") {
      result += "시외할아버지";
    } else if (formatType === "외손서") {
      //모름
      result += "외할아버지";
    } else if (formatType === "아들" || formatType === "딸") {
      //모름
      result += "아버지";
    } else if (formatType === "자부" || formatType === "며느리") {
      result += "시아버님";
    } else if (formatType === "사위") {
      result += "장인어른";
    } else if (formatType === "동생") {
      result += "형제";
    } else if (
      formatType === "형" ||
      formatType === "언니" ||
      formatType === "누나" ||
      formatType === "오빠"
    ) {
      result += "동생";
    } else if (formatType === "여동생") {
      result += "오빠";
    } else if (formatType === "남동생") {
      result += "형";
    } else if (formatType === "친구") {
      result += "친구";
    } else if (
      formatType === "삼촌" ||
      formatType === "이모" ||
      formatType === "고모"
    ) {
      result += "조카";
    } else if (formatType === "매형") {
      result += "처남";
    } else if (formatType === "아주버님") {
      result += "제수";
    } else if (formatType === "처제") {
      result += "형부";
    } else if (formatType === "처남") {
      result += "매형";
    } else if (formatType === "친인척") {
      result += "친인척";
    } else if (formatType === "상주") {
      result = "(상주 " + name + ")";
    } else {
      result = `(${formatType} ${name})`;
    }
  } else {
    if (formatType === "배우자" || formatType === "남편") {
      result += "아내";
    } else if (formatType === "부") {
      result += "딸";
    } else if (formatType === "모") {
      result += "딸";
    } else if (formatType === "외손") {
      result += "외할머니";
    } else if (formatType === "손") {
      result += "할머니";
    } else if (formatType === "손부") {
      result += "시할머님";
    } else if (formatType === "손서") {
      result += "처할머님";
    } else if (formatType === "외손부") {
      result += "시외할머니";
    } else if (formatType === "외손서") {
      //모름
      result += "외할머니";
    } else if (formatType === "아들" || formatType === "딸") {
      //모름
      result += "어머니";
    } else if (formatType === "자부" || formatType === "며느리") {
      result += "시어머님";
    } else if (formatType === "사위") {
      result += "장모님";
    } else if (formatType === "동생") {
      result += "형제";
    } else if (
      formatType === "형" ||
      formatType === "언니" ||
      formatType === "누나" ||
      formatType === "오빠"
    ) {
      result += "동생";
    } else if (formatType === "여동생") {
      result += "언니";
    } else if (formatType === "남동생") {
      result += "누나";
    } else if (formatType === "친구") {
      result += "친구";
    } else if (
      formatType === "삼촌" ||
      formatType === "이모" ||
      formatType === "고모"
    ) {
      result += "조카";
    } else if (formatType === "매형") {
      result += "처남";
    } else if (formatType === "아주버님") {
      result += "제수";
    } else if (formatType === "처제") {
      result += "형부";
    } else if (formatType === "처남") {
      result += "매형";
    } else if (formatType === "친인척") {
      result += "친인척";
    } else if (formatType === "상주") {
      result = "(상주 " + name + ")";
    } else {
      result = `(${formatType} ${name})`;
    }
  }

  result += " 故 " + dieName;

  return result;
}
